import { useState } from 'react'

export function useAuth() {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("cocafe_user")
    return stored ? JSON.parse(stored) : null
  })

  const testAccounts = {
    'athik@cocafe.host': { id: 'host_1', name: 'Athik Ahamed', role: 'host', password: 'demo123' },
    'priya@cocafe.host': { id: 'host_2', name: 'Priya Kapoor', role: 'host', password: 'demo123' },
    'raj@cocafe.host': { id: 'host_3', name: 'Raj Patel', role: 'host', password: 'demo123' },
    'vikram@cocafe.host': { id: 'host_4', name: 'Vikram Singh', role: 'host', password: 'demo123' },
    'neha@cocafe.host': { id: 'host_5', name: 'Neha Gupta', role: 'host', password: 'demo123' },
    'arun@cocafe.host': { id: 'host_6', name: 'Arun Kumar', role: 'host', password: 'demo123' },
    'aarav@email.com': { id: 'host_aarav', name: 'Aarav Menon', role: 'host', password: 'demo123' },
    'sneha@email.com': { id: 'host_sneha', name: 'Sneha Reddy', role: 'host', password: 'demo123' },
  }

  const handleLogin = async (creds) => {
    try {
      if (creds.isSignup) {
        if (!creds.email || !creds.password || !creds.name) {
          throw new Error('All fields are required')
        }
        if (creds.password.length < 6) {
          throw new Error('Password must be at least 6 characters')
        }
        const newUser = { id: `user_${Date.now()}`, name: creds.name, email: creds.email, role: creds.role }
        setUser(newUser)
        localStorage.setItem("cocafe_user", JSON.stringify(newUser))
      } else {
        if (!creds.email || !creds.password) {
          throw new Error('Email and password are required')
        }
        const userData = testAccounts[creds.email]
        if (!userData) throw new Error('Email not found. Please check and try again.')
        if (userData.password !== creds.password) throw new Error('Incorrect password. Please try again.')

        const user = { id: userData.id, name: userData.name, email: creds.email, role: userData.role }
        setUser(user)
        localStorage.setItem("cocafe_user", JSON.stringify(user))
      }
      return true
    } catch (err) {
      throw new Error(err.message)
    }
  }

  const handleLogout = () => {
    setUser(null)
    localStorage.removeItem("cocafe_user")
  }

  return {
    user,
    setUser,
    handleLogin,
    handleLogout,
  }
}
